import { theme } from "antd";

export default function useEntityModalTheme() {
  const { token } = theme.useToken();
  const dark = ["#000", "#000000"].includes(token.colorBgBase);
  return {
    "--entity-surface": token.colorBgContainer,
    "--entity-text": token.colorText,
    "--entity-heading": dark ? token.colorTextHeading : token.colorInfoTextActive,
    "--entity-label": dark ? token.colorTextSecondary : token.colorInfoText,
    "--entity-muted": token.colorTextSecondary,
    "--entity-border": token.colorBorderSecondary,
    "--entity-band": dark ? token.colorFillAlter : `color-mix(in srgb, ${token.blue1} 65%, ${token.colorBgContainer})`,
    "--entity-band-border": dark ? token.colorBorderSecondary : `color-mix(in srgb, ${token.blue2} 50%, ${token.colorBgContainer})`,
    "--entity-avatar": `color-mix(in srgb, ${token.colorText} 6%, ${token.colorBgContainer})`,
    "--entity-danger": dark ? `color-mix(in srgb, ${token.colorErrorText} 35%, ${token.colorText} 65%)` : token.colorErrorText,
    "--entity-focus": token.colorInfoText,
  };
}
